import axios from "axios";
import { API } from "@/lib/api";

const TOKEN_KEY = "cyan_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const authHeader = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export async function adminLogin(email, password) {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.access_token);
  return data.user;
}

export async function fetchMe() {
  const { data } = await axios.get(`${API}/auth/me`, { headers: authHeader() });
  return data;
}

export async function fetchLeads(type) {
  const url = type ? `${API}/leads?lead_type=${type}` : `${API}/leads`;
  const { data } = await axios.get(url, { headers: authHeader() });
  return data;
}

export async function fetchStats() {
  const { data } = await axios.get(`${API}/leads/stats`, { headers: authHeader() });
  return data;
}

export async function deleteLead(id) {
  const { data } = await axios.delete(`${API}/leads/${id}`, { headers: authHeader() });
  return data;
}
